<template>
  <div class="animated fadeIn">
    <component-header
      title="Delivery Setup"
      :isLoading="loading"
      @search-query="(val) => (filter = val)"
      @create-press="$router.push({ name: 'Create Deliverysetup' })"
      createButtonText="Create Delivery Charge"
      @reload-data="getDeliveryList"
      :hasClear="false"
    />
    <b-card>
      <div>
        <b-table
          style="border-radius: 12px"
          :dark="dark"
          :hover="hover"
          :striped="striped"
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          responsive
          id="my-table"
          :current-page="currentPage"
          :per-page="perPage"
          :items="deliverys"
          :filter="filter"
          thead-class="header"
          class="mt-3"
          :fields="Columns"
          :busy="loading"
          show-empty
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template slot="action" slot-scope="data">
            <div class="inline_btnTable">
              <b-button
                size="sm"
                class="mr-2 button-circle"
                variant="primary"
                @click="navigateTo(data.item, 'View Deliverysetup')"
              >
                <i class="fa fa-eye"></i>
              </b-button>
              <b-button
                size="sm"
                class="mr-2 button-circle"
                style="background: #fe7b08; border: #fe7b08;"
                variant="primary"
                @click="navigateTo(data.item, 'Edit Deliverysetup')"
              >
                <i class="fa fa-pencil"></i>
              </b-button>
              <b-button
                size="sm"
                class="button-circle"
                variant="danger"
                @click="deletedelivery(data)"
              >
                <i class="fa fa-trash bin"></i>
              </b-button>
            </div>
          </template>
          <template v-slot:empty="scope">
            <h4>{{ scope.emptyText }}</h4>
          </template>
          <template slot="city" slot-scope="data">
            <p>
              {{ data.item.city == "*" ? "All cities" : data.item.city }}
            </p>
          </template>
        </b-table>
      </div>
      <div style="float: right" v-if="deliverys.length > perPage">
        <b-pagination
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="deliverys.length"
          aria-controls="my-table"
          prev-text="Prev"
          pills
          next-text="Next"
          hide-goto-end-buttons
        ></b-pagination>
      </div>
      <!-- <p v-else style="text-align:center;padding-top:10px;">No data available!</p> -->
    </b-card>
  </div>
</template>
<script>
import ebButton from "@/components/FormElements/Button";
import loader from "@/components/loader/nipigeloader.vue";
import CreateDeliverysetup from "@/components/MasterSetup/deliverysetup/CreateDeliverysetup";
import EditDeliverysetup from "@/components/MasterSetup/deliverysetup/EditDeliverysetup";
import ViewDeliverysetup from "@/components/MasterSetup/deliverysetup/ViewDeliverysetup";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import currentUserData from "@/mixins/currentUser";
import ComponentHeader from "@/components/componentNewHeader";
export default {
  name: "DeliverySetup",
  mixins: [currentUserData],
  components: {
    ebButton,
    loader,
    CreateDeliverysetup,
    EditDeliverysetup,
    ViewDeliverysetup,
    ComponentHeader,
  },
  data() {
    return {
      deliveryData: [],
      loading: false,
      filter: "",
      perPage: 10,
      sortBy: "createdAt",
      sortDesc: true,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      dark: false,
      fixed: false,
      currentPage: 1,
      context: "Add",
      subscriptionData: {},
      Columns: [
        {
          key: "Id",
          sortable: true,
        },
        {
          key: "city",
        },
        {
          key: "areaCode",
        },
        {
          key: "StartDate",
        },
        {
          key: "EndDate",
        },
        {
          key: "dwf",
        },
        {
          key: "rank",
        },
        {
          key: "transportMode",
        },
        {
          key: "action",
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch("coupon/couponCodeList");
  },
  computed: {
    ...mapGetters({
      couponcode: "coupon/couponCodeList",
    }),

    deliverys() {
      let data = this.$store.getters["delivery/GetDeliveryList"];
      let deliveryList = [];

      if (Array.isArray(data) && data.length > 0) {
        data.map((e) => {
          let arrayObj = {
            StartDate: moment(e.startDate).format("DD/MM/yyyy"),
            EndDate: moment(e.endDate).format("DD/MM/yyyy"),
            city: e.city,
            category_id: e.category,
            Id: e._id,
            rank: e.rank,
            status: e.status,
            tenant: e.tenant,
            areaCode: e.areaCode,
            transportMode: e.transportMode,
            dwf: e.dwf,
            distance: e.distance,
            restData: e,
            ...e,
          };
          if (e.deliveryOwner) {
            if (e.deliveryOwner._id == this.$currentUserData._id) {
              deliveryList.push(arrayObj);
            }
          }
        });

        return deliveryList.sort(
          (a, b) =>
            new Date(b.restData.updatedAt) - new Date(a.restData.updatedAt)
        );
      } else {
        this.loading = false;
        return [];
      }
    },
  },
  methods: {
    async getDeliveryList() {
      this.loading = true;
      await this.$store.dispatch("delivery/fetchdeliverysList").then((data) => {
        if (data.message) {
          this.$toasted.error(data.message);
          this.loading = false;
        } else {
          this.loading = false;
        }
      });
    },
    navigateTo(data, path) {
      this.$router.push({ name: path, params: { data } });
    },
    deletedelivery(data) {
      var itemid = data.item._id;
      this.$swal({
        title: "Delete this Delivery setup details?",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("delivery/deleteDeliverySetup", itemid)
            .then((result) => {
              this.$toasted.success(
                "Delivery setup details Deleted Successfully"
              );
              this.$store
                .dispatch("delivery/fetchdeliverysList")
                .catch((error) => {
                  this.$toasted.error(error.message);
                });
            });
        }
      });
      this.$store.dispatch("delivery/fetchdeliverysList");
    },
  },
  async mounted() {
    this.getDeliveryList();
  },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
